import { Order } from '../interfaces';

export const formatCurrency = (
  amount: number,
  locale: string = 'en-NG',
  currency: string = 'NGN'
): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const convertSecondsToMinutesAndSeconds = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}m:${seconds}s`;
};

interface RemoveMultipleIndexes {
  <T>(arr: T[], indexes: number[]): T[];
}

export const removeMultipleIndexes: RemoveMultipleIndexes = (arr, indexes) => {
  return arr.filter((_, i) => !indexes.includes(i));
};

export const hasOrderWithPurchaseCode = (
  orders: Order[],
  purchaseCode: string
): boolean => orders.some((order) => order.purchaseCode === purchaseCode);

export const baseUrls = {
  staging: 'https://staging.izifin.com/merchant/api/',
  production: 'https://api.izifin.com/merchant/api/',
};

export const removeSkuPrefix = (sku: string): string => {
  return sku.split('-').slice(2).join('-');
};

export const getBaseUrl = (): string => {
  const env = localStorage.getItem('environment');
  const key: keyof typeof baseUrls =
    env === 'staging' ? 'staging' : 'production';
  console.log('Base URL:', baseUrls[key]);
  return baseUrls[key];
};
